import React, { useState } from 'react';
import './BhajanCard.css';

const BhajanCategoryCard = ({ bhajan, categoryId, onDelete, onEdit }) => {
  const [expanded, setExpanded] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editTitle, setEditTitle] = useState(bhajan.title);
  const [editText, setEditText] = useState(bhajan.bhajan_text);

  const formatDate = (dateString) => {
    if (!dateString) return 'Unknown date';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-IN', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  const truncateText = (text, maxLength = 100) => {
    if (!text) return '';
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
  };

  const handleEditClick = () => {
    setEditTitle(bhajan.title);
    setEditText(bhajan.bhajan_text);
    setIsEditing(true);
  };

  const handleCancelEdit = () => {
    setIsEditing(false);
    setEditTitle(bhajan.title);
    setEditText(bhajan.bhajan_text);
  };

  const handleSaveEdit = () => {
    if (onEdit) {
      onEdit(categoryId, bhajan.title, editTitle, editText);
    }
    setIsEditing(false);
  };

  return (
    <>
      {/* Edit Modal */}
      {isEditing && (
        <div className="edit-modal-overlay" onClick={(e) => e.stopPropagation()}>
          <div className="edit-modal">
            <h2>✏️ Edit Bhajan</h2>
            <div className="edit-form">
              <label>Title:</label>
              <input
                type="text"
                value={editTitle}
                onChange={(e) => setEditTitle(e.target.value)}
              />
              <label>Bhajan Text:</label>
              <textarea
                value={editText}
                onChange={(e) => setEditText(e.target.value)}
                rows={10}
              />
              <div className="edit-modal-buttons">
                <button className="save-button" onClick={handleSaveEdit}>💾 Save</button>
                <button className="cancel-button" onClick={handleCancelEdit}>❌ Cancel</button>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="bhajan-card">
        <div className="bhajan-header">
          <h5 className="bhajan-title">{bhajan.title}</h5>
          <div className="bhajan-actions">
            <button
              className="edit-bhajan-btn"
              onClick={handleEditClick}
              title="Edit this bhajan"
            >
              ✏️
            </button>
            <button
              className="delete-bhajan-btn"
              onClick={() => onDelete(categoryId, bhajan.title)}
              title="Delete this bhajan"
            >
              🗑️
            </button>
          </div>
        </div>

        <div className="bhajan-content">
          <div className="bhajan-text">
            {expanded ? (
              <pre className="bhajan-text-full">{bhajan.bhajan_text}</pre>
            ) : (
              <p className="bhajan-text-preview">
                {truncateText(bhajan.bhajan_text, 150)}
              </p>
            )}
          </div>

          {bhajan.bhajan_text && bhajan.bhajan_text.length > 150 && (
            <button
              className="expand-btn"
              onClick={() => setExpanded(!expanded)}
            >
              {expanded ? '📖 Show Less' : '📜 Read Full'}
            </button>
          )}
        </div>

        <div className="bhajan-footer">
          <div className="bhajan-meta">
            <span className="bhajan-date">
              📅 {formatDate(bhajan.created_at)}
            </span>
            <span className="bhajan-length">
              📝 {bhajan.bhajan_text?.length || 0} chars
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export default BhajanCategoryCard;